import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { m } from 'framer-motion'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import { Box } from '@mui/material'

import customConfig from 'customConfig'
import { FormReturnLink } from 'src/auth/components/form-return-link'
import { SimpleLayout } from 'src/layouts/simple'
import { PageNotFoundIllustration } from 'src/assets/illustrations'

import { varBounce, MotionContainer } from 'src/components/animate'
import PageTitle from '../shared/pageTitle/PageTitle'

const PageNotFound = ({ auth, onBackToHome, onCancelLink }) => {
  const { t } = useTranslation()
  const pageTitle = t('page-not-found.not-found')
  return (
    <>
      <PageTitle title={pageTitle} noHeading />
      <SimpleLayout
        slotProps={{
          content: { compact: true }
        }}
      >
        <Container component={MotionContainer}>
          <m.div variants={varBounce('in')}>
            <Typography variant='h3' sx={{ mb: 2 }}>
              {pageTitle}
            </Typography>
          </m.div>

          <m.div variants={varBounce('in')}>
            <Typography sx={{ color: 'text.secondary' }}>
              {t(customConfig.couldNotFindPageLabel)}
            </Typography>
          </m.div>

          <m.div variants={varBounce('in')}>
            <PageNotFoundIllustration sx={{ my: { xs: 5, sm: 10 } }} />
          </m.div>

          <Button size='large' variant='contained' onClick={onBackToHome}>
            {t('page-not-found.back-to-home')}
          </Button>
          <Box sx={{ display: 'block' }}>
            <FormReturnLink
              label={auth ? t(customConfig.myAccountLabel) : t('login.log-in')}
              onClick={onCancelLink}
            />
          </Box>
        </Container>
      </SimpleLayout>
    </>
  )
}

export default memo(PageNotFound)
